module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/3/5-53053abafb02c136369113e33733505c.jpg";